<app-toolbar></app-toolbar>
<div class="grid-container">
	<div class="barra-pesquisa">
	</div>
</div>
<div class="grid-container">
	@if (isCliente) {
	<div class="carrossel-component">
		<app-carrossel-cabecalho
		  (idsPesquisaEmitter)="getIdsConsultaPaineis($event)"
		  (ordemEmitter)="setOrdemPainel($event)"
		  (filtroEmitter)="setAbrirFiltroPainel($event)"
		  [ordenacaoInput]="ordenacaoDefault">
		</app-carrossel-cabecalho>
	</div>
	}
</div>

@if (estadosDaPesquisa.estadoInicial && bannersHome.length > 0 && !exibeConsultaPainelLogin) {
<div class="banner-home-section">
	<app-banner-carrossel
		[banners]="bannersHome"
		[intervaloMs]="tempoSlideBanners"
		(bannerClicado)="onBannerClicado($event)">
	</app-banner-carrossel>
</div>
}

<div>
	@if (!estadosDaPesquisa.estadoInicial && !this.estadosDaPesquisa.registrosEncontrados && !isLoading) {
	<div>
		<div class="alinhar-itens">
			<mat-icon color="warn" class="icone-nao-encontrado">warning</mat-icon>
			<h3>Nenhum item encontrado</h3>
		</div>
	</div>
	}
	<div class="alinhar-itens">
		@if (!this.estadosDaPesquisa.estadoInicial && !this.estadosDaPesquisa.pesquisaPronta || isLoading) {
		<mat-spinner class="spinner-align" mode="indeterminate">
		</mat-spinner>
		}
	</div>
	@if (this.estadosDaPesquisa.registrosEncontrados) {
	<div>
		@if (this.estadosDaPesquisa.pesquisaPronta && this.estadosDaPesquisa.registrosEncontrados) {
		<app-painel
			[idsPesquisados]="idsPesquisados"
			(ordenacaoDefaultEmitter)="setOrdenacaoInput($event)">
		</app-painel>
		}
	</div>
	}
</div>
<app-rodape></app-rodape>
